<ng-container *ngFor="let category of mainCategories">
    <div *ngIf="!!category.category_name || !!category.category_url" class="categories-mat-menu">
        <a class = "imgStyle" [routerLink] = "['/categories',  category['category_url']]" (click)="changeCategory($event, category, '')">
            <button mat-menu-item (click)="changeCategory($event, category, '')">
                <span [innerHTML]="category.category_name | sanitizeHtml"> </span>
            </button>
        </a>
        <div *ngIf="category['sub_list']" class="sub-category">
            <div *ngIf="category['sub_list'].length > 0">
                <a class = "imgStyle clr" *ngFor="let subCat of category['sub_list']" [routerLink]="['/categories', category['category_url'] , subCat['category_url']]"
                (click)="changeCategory($event, subCat, category)">
                    <button mat-menu-item  (click)="changeCategory($event, subCat, category)">    
                        <span  [innerHTML]="subCat.category_name | sanitizeHtml "></span>
                    </button>
                </a>
            </div>    
        </div>
    </div>
</ng-container>